!function() {
  "use strict";

  const e = {
    marquee: ".announcement__bar-holder--marquee",
    slide: "[data-slide]",
    slider: "[data-slider]",
    ticker: ".ticker-bar",
    tickerSlide: ".announcement__slide"
  };

  if (!customElements.get("announcement-bar")) {
    customElements.define("announcement-bar", class extends HTMLElement {
      constructor() {
        super();
        // Bound handlers (pre-bound to prevent memory leaks)
        this.resizeHandler = this.resize.bind(this);
        this.handleSliderLoaded = this.sliderLoaded.bind(this);
        this.handleCountdownHide = this.countdownHide.bind(this);
        this.handleCountdownExpire = this.countdownExpire.bind(this);
      }

      connectedCallback() {
        // Cache slider once DOM is ready
        if (!this.slider) this.slider = this.querySelector(e.slider);

        // Listen to internal events
        this.addEventListener("theme:slider:loaded", this.handleSliderLoaded);
        this.addEventListener("theme:countdown:hide", this.handleCountdownHide);
        this.addEventListener("theme:countdown:expire", this.handleCountdownExpire);

        // Global resize listener
        document.addEventListener("theme:resize:width", this.resizeHandler);

        // Fire init once per page
        if (!window.__announcementInitFired) {
          document.dispatchEvent(new CustomEvent("theme:announcement:init", { bubbles: true }));
          window.__announcementInitFired = true;
        }
      }

      sliderLoaded() {
        this.querySelectorAll(e.ticker).forEach((t) => {
          t.dispatchEvent(new CustomEvent("theme:ticker:refresh"));
        });
      }

      countdownHide(t) {
        if (window.Shopify?.designMode) return;
        const s = t.target;
        if (!s) return;

        if (s.closest(e.marquee)) {
          this.removeTickerText(s.closest(e.tickerSlide));
        } else {
          this.removeSlide(s.closest(e.slide));
        }
      }

      countdownExpire() {
        this.querySelectorAll(e.ticker).forEach((t) => {
          t.dispatchEvent(new CustomEvent("theme:ticker:refresh"));
        });
      }

      resize() {
        if (!this.slider) {
          this.slider = this.querySelector(e.slider);
          if (!this.slider) return;
        }

        clearTimeout(this._resizeTimer);
        this._resizeTimer = setTimeout(() => {
          if (!this.isConnected || !this.slider) return;
          this.slider.dispatchEvent(new CustomEvent("theme:slider:init", { bubbles: false }));
          this.slider.dispatchEvent(new CustomEvent("theme:slider:reposition", { bubbles: false }));
        }, 150);
      }

      removeSlide(t) {
        if (!this.slider || !t) return;
        this.slider.dispatchEvent(new CustomEvent("theme:slider:remove-slide", {
          bubbles: false,
          detail: { slide: t }
        }));
      }

      removeTickerText(t) {
        if (!t) return;
        const s = t.closest(e.ticker);
        t.remove();

        if (s) {
          const remaining = s.querySelectorAll(e.tickerSlide).length;
          if (remaining < 2) s.style.display = "none";
          s.dispatchEvent(new CustomEvent("theme:ticker:refresh"));
        }
      }

      disconnectedCallback() {
        document.removeEventListener("theme:resize:width", this.resizeHandler);
        this.removeEventListener("theme:slider:loaded", this.handleSliderLoaded);
        this.removeEventListener("theme:countdown:hide", this.handleCountdownHide);
        this.removeEventListener("theme:countdown:expire", this.handleCountdownExpire);
        clearTimeout(this._resizeTimer);
      }
    });
  }
}();
